(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["minevre-editorial-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.mnv-editorial-drawer > details')) return;
    const trigger = details.querySelector(':scope > summary');
    if (details.open) {
      trigger?.setAttribute('tabindex', '-1');
      const panel = details.querySelector('.mnv-editorial-drawer__panel');
      if (panel) panel.scrollTop = 0;
      requestAnimationFrame(() => details.querySelector('.mnv-editorial-drawer__close')?.focus({ preventScroll: true }));
    } else {
      trigger?.removeAttribute('tabindex');
      if (trigger?.getClientRects().length) trigger.focus({ preventScroll: true });
    }
  }, true);
  document.addEventListener('transitionend', (event) => {
    const panel = event.target;
    if (!(panel instanceof HTMLElement) || !panel.matches('.mnv-editorial-drawer__panel')) return;
    if (panel.parentElement?.classList.contains('menu-open')) {
      requestAnimationFrame(() => panel.querySelector('.mnv-editorial-drawer__close')?.focus({ preventScroll: true }));
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
